import { useEffect, useState } from "react";
import { api, getToken } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Supporters() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/supporters").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this supporter entry?")) return;
    await api.delete(`/admin/supporters/${id}`);
    toast.success("Deleted");
    load();
  };

  const exportCsv = async () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/supporters/export`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${getToken()}` } });
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "supporters.csv";
    a.click();
  };

  return (
    <div data-testid="admin-supporters" className="space-y-6">
      <header className="flex items-center justify-between">
        <div>
          <div className="label-eyebrow mb-2">Submissions</div>
          <h1 className="font-display text-4xl text-[hsl(var(--primary))]">Supporters ({list.length})</h1>
        </div>
        <Button onClick={exportCsv} data-testid="export-supporters-btn"
          className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary-hover))] rounded-none uppercase tracking-widest">
          <Download size={14} className="mr-2" /> Export CSV
        </Button>
      </header>
      <div className="bg-white border border-[hsl(var(--border-c))] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[hsl(var(--bg-muted))]">
            <tr>
              {["Name", "Phone", "Email", "Message", "When", ""].map((h) => (
                <th key={h} className="text-left p-3 font-medium uppercase text-[10px] tracking-widest">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} className="border-t border-[hsl(var(--border-c))]">
                <td className="p-3 font-medium">{r.name}</td>
                <td className="p-3">{r.phone}</td>
                <td className="p-3">{r.email || "—"}</td>
                <td className="p-3 max-w-xs truncate">{r.message || "—"}</td>
                <td className="p-3 text-[hsl(var(--fg-muted))]">{new Date(r.created_at).toLocaleString()}</td>
                <td className="p-3">
                  <button onClick={() => remove(r.id)} data-testid={`del-supporter-${r.id}`} className="text-[hsl(var(--accent))] hover:underline">
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
            {list.length === 0 && (
              <tr><td colSpan={6} className="p-6 text-center text-[hsl(var(--fg-muted))]">No supporters yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
